<template>
    <div>
        <CCard class="mb-2"
            :class="(usuario.habilitado)?'cardHabil':'cardDeshab'"
            @mouseover="focus = true" 
            @mouseout="focus = false">
            <CCardHeader>

                <!--<div class="card-header-actions float-left">
                    <CLink class="card-header-action btn-minimize" @click="expandirCliente">
                        <CIcon v-show="mostrarMas" :content="$options.freeSet.cilChevronTop" />
                        <CIcon v-show="!mostrarMas" :content="$options.freeSet.cilChevronBottom" />
                    </CLink>
                </div>-->
                <CRow>
                    <CCol col="12">
                        <div class="mb-3" style="font-size: 13px;">
                            <span class="font-weight-bold">
                                <span v-tippy="getBaseTippy('Tipo de usuario')">
                                    ({{(usuario.usuarioAdmin)?"Admin":(usuario.usuarioRevision?"Revisión":"Normal")}})
                                </span>
                                <span v-tippy="getBaseTippy('Username')">
                                    {{usuario.userPropio?"(Yo)":""}} {{ usuario.userName }}
                                </span>
                            </span>
                            <span>
                                <span v-tippy="getBaseTippy('Rut Usuario')">
                                    ({{ usuario.rutUsuario }})
                                </span>
                                <!--<span v-tippy="getBaseTippy('Correo Usuario')">
                                    {{ usuario.mailUsuario }}
                                </span>-->
                                <span v-show="focus">
                                    <CButtonGroup size="sm" class="ml-2" v-show="!usuario.editar">
                                        <CButton color="warning" size="sm"
                                            style="height: 25px; padding-top: 0; padding-bottom: 0;"
                                            :content="'Editar Usuario'"                                            
                                            v-tippy="{ 
                                                placement: 'top',
                                                arrow: true, 
                                                arrowType: 'round', 
                                                animation:'perspective',
                                                theme: 'google',
                                                followCursor : true,
                                            }"
                                            @click="usuario.editar = true; editarUser();"
                                        >
                                            <CIcon name="cil-pencil" style="height: 12px;" />
                                        </CButton>
                                    </CButtonGroup>
                                </span>
                                <!--<span>Creado {{ formatFecha(usuario.fechaCreacion) }}</span>-->
                            </span>
                        </div>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol col="5">
                        <div class="infoDetalle p-1" v-tippy="getBaseTippy(`${usuario.nombreUsuario} ${usuario.apellidoUsuario}`)">
                            <span class="font-weight-bold">Nombre: </span>
                            <span>{{usuario.nombreUsuario}} {{usuario.apellidoUsuario}}</span>
                        </div>
                         <div class="infoDetalle p-1">
                            <span class="font-weight-bold">Correo Usuario: </span>
                            <span v-tippy="getBaseTippy(usuario.mailUsuario)">{{ usuario.mailUsuario }}</span>
                        </div> 
                    </CCol>
                    <CCol col="7">
                        <CRow>
                            <CCol>
                                <div class="infoDetalle p-1">
                                    <span>
                                        <CIcon style="color:green" name="cil-check-circle" v-show="usuario.habilitadoCompartir"/>
                                        <CIcon style="color:red" name="cil-x-circle" v-show="!usuario.habilitadoCompartir" />
                                    </span>
                                    <span>Habilitado Carp. Compartir</span>
                                </div> 
                                <div class="infoDetalle p-1">
                                    <span>
                                        <CIcon style="color:green" name="cil-check-circle" v-show="usuario.sueldoEmpresarial"/>
                                        <CIcon style="color:red" name="cil-x-circle" v-show="!usuario.sueldoEmpresarial" />
                                    </span>
                                    <span>Ve Sueldo Empresarial</span>
                                </div> 
                                <div class="infoDetalle p-1">
                                    <span>
                                        <CIcon style="color:green" name="cil-check-circle" v-show="usuario.usuarioEliminado"/>
                                        <CIcon style="color:red" name="cil-x-circle" v-show="!usuario.usuarioEliminado" />
                                    </span>
                                    <span>Usuario Eliminado</span>
                                </div> 
                            </CCol>
                            <CCol class="vertical-line" v-tippy="getBaseTippy('Es solo una idea para filtrar el tipo de BD de cada usuario')">
                                <div class="font-weight-bold">BD's:</div>
                                <div class="infoDetalle p-1">
                                    <span>
                                        <!--<CIcon style="color:green" name="cil-check-circle" v-show="usuario.tipoBdRemu"/>-->
                                        <CIcon style="color:red" name="cil-x-circle" />
                                    </span><span>Remu</span>
                                </div> 
                                
                                <div class="infoDetalle p-1">
                                    <span>
                                        <!--<CIcon style="color:green" name="cil-check-circle" v-show="usuario.tipoBdConta"/>-->
                                        <CIcon style="color:red" name="cil-x-circle" />
                                    </span><span>Conta</span>
                                </div> 
                            </CCol>
                        </CRow>

                    </CCol>

                </CRow>
            </CCardHeader>
        </CCard>
        <EditarUsuario :usuario="usuario" :cliente="cliente" />
    </div>
            
</template>

<script>
    import Vue from 'vue'
    import cons from "@/const";
    import axios from "axios";
    import { freeSet } from "@coreui/icons";

    import EditarUsuario from '../Modals/EditarUsuario.vue'

    
    import { format, formatDistance, formatRelative, subDays } from "date-fns";
    import es from "date-fns/locale/es";
    window.locale = "es";

    
    

    export default {
        name: "UsuarioInfo",
        freeSet,
        props: {
            cliente: Object,
            usuario: Object
        },
        components: {
            EditarUsuario
        },
        data() {
            return {
                paginaActual: 1,

                baseUrl: cons.protocolo + "://" + cons.ipServer + cons.puerto,

                tokenLogin: JSON.parse(this.$cookie.get("userLogginTokenAdmin")).tokenUsuario,

                mostrarMas: false,
                focus: false,


            };
        },
        created: function () {},
        beforeMount() {
        },
        mounted() {},
        methods: {
            formatFecha: function(fecha){
                //return format(new Date(fechaDoc), 'EEE d LLL/yy H:mm:ss', {locale: es})//'dd/MM/yyyy' 'EEE d LLL/yy H:mm:ss'
                if(fecha != null)
                    return formatDistance(new Date(fecha), new Date(), { addSuffix: true, locale: es})//.isSame(moment().clone().startOf('day'), 'd')
                else
                    return "Nunca"
                
            },
            editarUser: function(){
                this.usuario.respaldoUser = JSON.parse(JSON.stringify(this.usuario))
                
                

                /*{
                    "idUsuario": this.usuario.idUsuario,
                    "userName": this.usuario.userName,
                    "rutUsuario": this.usuario.rutUsuario,
                    "nombreUsuario": this.usuario.nombreUsuario,
                    "apellidoUsuario": this.usuario.apellidoUsuario,
                    "habilitado": this.usuario.habilitado,
                    "idCliente": this.usuario.idCliente,
                    "usuarioAdmin": this.usuario.usuarioAdmin,
                    "usuarioRevision": this.usuario.usuarioRevision,
                    "usuarioNormal": this.usuario.usuarioNormal,
                    "mailUsuario": this.usuario.mailUsuario,
                    "habilitadoCompartir": this.usuario.habilitadoCompartir,
                    "editar": false
                }*/
            },

        },
    };
</script>

<style>

    .cardHabil{
        border-color: green;
    }
    .cardDeshab{
        border-color: red;
    }

    .vertical-line {
        border-left: 1px solid rgb(37, 37, 43);
        height: 100px; /* Ajusta la altura de la línea */
        margin-left: 20px; /* Ajusta el margen si es necesario */
    }
</style>